import { getQueryString } from '@sonar-software/sonar-http';
import { SonarObjectTypeId } from '@sonar-software/sonar-ts-types';
export function getResourceIdsUri(options) {
    const { childType, parentType, sonarObjectId } = options;
    const tagPrefix = parentType === SonarObjectTypeId.SonarTag ? 'tag-' : '';
    return `v3/core/sonar-objects/${sonarObjectId}/${tagPrefix}children?${getQueryString(Object.assign({ childSonarObjectType: childType }, !tagPrefix && { parentSonarObjectType: parentType }))}`;
}
export function useBulkSelectWorkflow(options) {
    return {
        resourceIdsUri: getResourceIdsUri(options)
    };
}
